<template>
  <div class="dr-biz-login">
    <!-- 已登录：显示用户名 + 下拉菜单 -->
    <el-dropdown v-if="isLogin" trigger="hover" @command="onCommand">
      <span class="dr-biz-login__user">
        <i v-if="showAvatar" class="el-icon-user dr-biz-login__avatar"></i>
        <span>{{ (userInfo && (userInfo.nickname || userInfo.username)) || $t('message.home.username') }}</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="profile">{{ $t('message.home.userCenter') }}</el-dropdown-item>
        <el-dropdown-item command="orders">{{ $t('message.home.myOrder') }}</el-dropdown-item>
        <el-dropdown-item command="logout" divided>{{ $t('message.home.logout') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 未登录：登录 / 注册 -->
    <span v-else class="dr-biz-login__guest">
      <i v-if="showAvatar" class="el-icon-user dr-biz-login__avatar"></i>
      <a class="dr-biz-login__link" @click="goLogin">{{ $t('message.home.login') }}</a>
      <span class="dr-biz-login__sep">/</span>
      <a class="dr-biz-login__link" @click="goRegister">{{ $t('message.home.register') }}</a>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DrLoginBlock',
  props: {
    showAvatar: { type: Boolean, default: true }
  },
  computed: {
    ...mapGetters(['userInfo', 'isLogin'])
  },
  methods: {
    ...mapActions(['logout']),
    goLogin() { this.$router.push('/login') },
    goRegister() { this.$router.push('/register') },
    onCommand(cmd) {
      if (cmd === 'profile') this.$router.push('/userInfo/dashboard')
      else if (cmd === 'orders') this.$router.push('/userInfo/my-order')
      else if (cmd === 'logout') {
        this.logout && this.logout()
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.dr-biz-login { display: inline-flex; align-items: center; font-size: 13px; }
.dr-biz-login__user, .dr-biz-login__guest { display: inline-flex; align-items: center; gap: 4px; cursor: pointer; }
.dr-biz-login__avatar { font-size: 16px; color: var(--theme-text-secondary, #606266); }
.dr-biz-login__link { color: var(--theme-text-primary, #303133); text-decoration: none; }
.dr-biz-login__link:hover { color: var(--theme-primary, #4d6bfe); }
.dr-biz-login__sep { margin: 0 4px; color: var(--theme-text-secondary, #909399); }
</style>
